import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { hasPrivilege } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import { selectedSome } from '../../stores/tables/selectors'; 
import ExportReportAction from './actions/ExportReportAction';
import TableToolbar from '../table/TableToolbar';
import AssignApplicationsWorkspaceAction from './actions/AssignApplicationsWorkspaceAction';
import AssignGroupsWorkspacesAction from './actions/AssignGroupsWorkspacesAction';
import CopyWorkspaceAction from './actions/CopyWorkspaceAction';
import DeleteWorkspacesAction from './actions/DeleteWorkspacesAction';

interface Props extends LocalizeContextProps, RouteComponentProps {
    selectedSome: boolean;
    hasPrivilege: (privileges: string[]) => boolean;
}

interface State {
    showActions: boolean;
}

class WorkspacesToolbar extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showActions: false
        };
    }

    public render() {
        const t = this.props.translate;
        return (
            <TableToolbar>
                {this.renderActionMenu()}
                <ExportReportAction />
                {/* <CSVImportAction /> */}
                <Button
                    color="primary"
                    className="action-btn"
                    onClick={() => {
                        this.props.history.push(`/workspaces/new`);
                    }}
                >
                    <FontAwesomeIcon
                        className="mr-4"
                        icon={['fal', 'plus']}
                    />
                    {t('workspaces.button.add')}
                </Button>
            </TableToolbar>
        );
    }

    private renderActionMenu = () => {
        const t = this.props.translate;
        const menuItems = _.compact(this.renderActions());

        if (menuItems.length > 0) {
            return (
                <ButtonDropdown
                    id="action-buttons"
                    className="action-btn"
                    color="default"
                    title={t('workspaces.button.actions') as string}
                    isOpen={this.state.showActions}
                    toggle={() => { this.setState({ showActions: !this.state.showActions }); }}
                    style={{ marginRight: '10px' }}
                >
                    <DropdownToggle caret={true}>
                        {t('workspaces.button.actions')}
                    </DropdownToggle>
                    <DropdownMenu persist={true}>
                        {menuItems}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        } else {
            return <div />;
        }
    }

    private renderActions = () => {
        const t = this.props.translate;
        if (this.props.selectedSome) {
            return (
                [
                    <CopyWorkspaceAction key={1} />, // TODO
                    <AssignApplicationsWorkspaceAction key={2} />, // TODO
                    <AssignGroupsWorkspacesAction key={3} />, // TODO
                    <DeleteWorkspacesAction key={4} />, // TODO
                ]
            );

        } else {
            return [];
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedSome: selectedSome(state, 'workspaces'),
});

export default connect(mapStateToProps)(withLocalize(withRouter(WorkspacesToolbar)));